export default {
  getPositionList: (state) => state.positionList,
  getPositionIdAndNameList: (state) =>
    state.positionList.map(({ positionName, positionId }) => ({
      name: positionName,
      id: positionId,
    })),
  getSelectedPositionId: (state) => state.selectedPosition.positionId,
  getSelectedPositionName: (state) => state.selectedPosition.positionName,
  getCurrentAbilityAddDriver: (state) => state.selectedPosition.addDriver,
  getCurrentAbilityEditDriver: (state) => state.selectedPosition.editDriver,
  getCurrentAbilityDriverService: (state) =>
    state.selectedPosition.defaultDriverService,
  getCurrentAbilityDriverMonitor: (state) =>
    state.selectedPosition.driverMonitor,
  getCurrentAbilityDriverTrajectory: (state) =>
    state.selectedPosition.driverTrajectory,
  getCurrentAbilityDriverMessage: (state) =>
    state.selectedPosition.driverMessage,
  getCurrentAbilityTransaction: (state) => state.selectedPosition.transaction,
  getCurrentAbilityTransactionStatistics: (state) =>
    state.selectedPosition.transactionStatistics,
  getCurrentAbilityCustomer: (state) => state.selectedPosition.customer,
  getCurrentAbilityStore: (state) => state.selectedPosition.store,
  getCurrentAbilityLandmark: (state) => state.selectedPosition.landmark,
  getCurrentAbilityReservation: (state) => state.selectedPosition.reservation,
  getCurrentAbilityDispatchArea: (state) => state.selectedPosition.dispatchArea,
  getCurrentAbilityScheduledArea: (state) =>
    state.selectedPosition.scheduledArea,
  getCurrentAbilityScheduledBoard: (state) =>
    state.selectedPosition.scheduledBoard,
  getCurrentAbilityMobilePayment: (state) =>
    state.selectedPosition.mobilePayment,
  getCurrentAbilityUserManagement: (state) =>
    state.selectedPosition.userManagement,
  getCurrentAbilityUserBehavior: (state) => state.selectedPosition.userBehavior,
  getCurrentAbilityPositionManagement: (state) =>
    state.selectedPosition.positionManagement,
  getCurrentAbilityTransactionRecord: (state) =>
    state.selectedPosition.instanceTransactionRecord,
  getCurrentAbilityCallCar: (state) => state.selectedPosition.callCar,
  getCurrentAbilitySaveHailBill: (state) => state.selectedPosition.saveHailBill,
  getCurrentAbilitySaveReservation: (state) =>
    state.selectedPosition.saveReservation,
  getCurrentAbilityAnnouncement: (state) => state.selectedPosition.announcement,
  getCurrentAbilityUserDeletion: (state) => state.selectedPosition.userDeletion,
}



// WEBPACK FOOTER //
// ./src/store/positionStore/getters.js